export default __webpack_public_path__ + "static/media/envelope-regular.72a16712.png";